import "./google_map.js";

window.Sparkle ??= {};
window.Sparkle.Views ??= {};

Sparkle.Views.MapWithLocationList = class MapWithLocationList extends Sparkle.Views.GoogleMap {
  constructor(options) {
    super(options);
    this.addMarkersToMap = this.addMarkersToMap.bind(this);
    if (options == null) {
      options = {};
    }
    this.collection = options.collection;
  }

  addMarkersToMap() {
    return this.collection.forEach((location) => {
      const address = location.addresses[0];
      if (!address || !address.lat || !address.lng) {
        return;
      }

      const latLng = new google.maps.LatLng(address.lat, address.lng);
      this.bounds.extend(latLng);

      const marker = new google.maps.Marker({ position: latLng, map: this.mapObject, title: location.name });

      return this.createInfoWindow(marker, this.infoWindowTemplate(location));
    });
  }
};
